var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsNumber, IsOptional, IsString, IsUUID, IsUppercase, Matches, MaxLength, MinLength, ValidateIf, } from 'class-validator';
import { countryRegex } from '../../countries.js';
import { IsTelephoneNumber } from '../../user/validators/IsTelephoneNumber.decorator.js';
export class CreateOfficeLocationDto {
    name;
    abbreviation;
    ownerId;
    street;
    zip;
    town;
    countryCode;
    subdivisionCode;
    usesSeparateInvoiceAddress;
    companyNameForInvoice;
    streetForInvoice;
    zipForInvoice;
    townForInvoice;
    countryCodeForInvoice;
    /** The phone field's own check (libphonenumber); empty means no number. */
    telephone;
    /**
     * @deprecated No longer used. Kept as an optional, ignored field so older
     * frontend bundles that still send it don't trip `forbidNonWhitelisted`.
     * Remove once no old clients remain.
     */
    countTherapists;
    email;
    addAllTherapistsToOfficeLocation;
    addAllManagementUsersToOfficeLocation;
}
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsUppercase(),
    MinLength(1),
    MaxLength(4),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "abbreviation", void 0);
__decorate([
    IsUUID(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "ownerId", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "street", void 0);
__decorate([
    IsString(),
    MinLength(4),
    MaxLength(5),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "zip", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "town", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    Matches(countryRegex),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "countryCode", void 0);
__decorate([
    IsString(),
    MaxLength(8),
    IsOptional(),
    __metadata("design:type", Object)
], CreateOfficeLocationDto.prototype, "subdivisionCode", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateOfficeLocationDto.prototype, "usesSeparateInvoiceAddress", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "companyNameForInvoice", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "streetForInvoice", void 0);
__decorate([
    IsString(),
    MaxLength(5),
    IsOptional(),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "zipForInvoice", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "townForInvoice", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "countryCodeForInvoice", void 0);
__decorate([
    ValidateIf((_, value) => value !== null && value !== undefined && value !== ''),
    IsString(),
    IsTelephoneNumber(),
    __metadata("design:type", Object)
], CreateOfficeLocationDto.prototype, "telephone", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateOfficeLocationDto.prototype, "countTherapists", void 0);
__decorate([
    IsString(),
    IsOptional(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateOfficeLocationDto.prototype, "email", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateOfficeLocationDto.prototype, "addAllTherapistsToOfficeLocation", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateOfficeLocationDto.prototype, "addAllManagementUsersToOfficeLocation", void 0);
//# sourceMappingURL=create-office-location.dto.js.map